var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryTravel32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1710.000000, -796.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/Travel32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconTravel",
    transform: "translate(-2.000000, -3.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plane",
    transform: "translate(18.405697, 18.627162) rotate(45.000000) translate(-18.405697, -18.627162) translate(5.905697, 6.127162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5929654,22.5166599 L13.5929654,21.4666599 L13.5929654,11.6702319 L23.0215368,13.6345176 L23.0215368,12.102417 L13.5929654,8.1738456 L13.5929654,2.42863541 C13.5929654,1.80722294 13.0783787,1.29289322 12.4501082,1.29289322 C11.8133761,1.29289322 11.3072511,1.79868296 11.3072511,2.42863541 L11.3072511,8.1738456 L1.87867966,12.102417 L1.87867966,13.6345176 L11.3072511,11.6702319 L11.3072511,21.4666599 L8.30725109,22.5166599 L8.30725109,23.1124328 L12.4501082,22.4219566 L16.5929654,23.1124328 L16.5929654,22.5166599 Z M14.5929654,12.9000361 L14.5929654,20.7571789 L17.5929654,21.8071789 L17.5929654,24.2928932 L12.4501082,23.4357504 L7.30725109,24.2928932 L7.30725109,21.8071789 L10.3072511,20.7571789 L10.3072511,12.9000361 L0.878679656,14.8643218 L0.878679656,11.4357504 L10.3072511,7.50717893 L10.3072511,2.42863541 C10.3072511,1.24909757 11.25839,0.292893219 12.4501082,0.292893219 C13.6335755,0.292893219 14.5929654,1.25784876 14.5929654,2.42863541 L14.5929654,7.50717893 L24.0215368,11.4357504 L24.0215368,14.8643218 L14.5929654,12.9000361 Z",
    id: "Combined-Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryTravel32);
export default __webpack_public_path__ + "static/media/spendCategoryTravel32.ac41aaa9fd1f3bfcbcfa6981892aa4cf.svg";
export { ForwardRef as ReactComponent };